<template>
  <div style="margin-top:54px">
    <h2 class="title">信息查询</h2>
    <div class="urlbox">
      <a href="https://zhcpw.org.cn/login" style="background-image:url(/static/img/img/kaoshhiziaxin.png);" class="item">在线测评</a>
      <router-link to="/inquery?inqtype=px" style="background-image:url(/static/img/img/xinxichxun.png);" class="item">信息查询</router-link>
      <router-link to="/InqMember" style="background-image:url(/static/img/img/huiyuanchuaxun.png);" class="item">会员查询</router-link>
      <router-link to="/inquery?inqtype=ry" style="background-image:url(/static/img/img/ronyuchaxun.png);" class="item">测评智库</router-link>
    </div>
  </div>
</template>

<script>
import {getArticles} from '@/request/get'
import { IP_TEST } from '@/config'
export default {
  name: "EnvironmentService",
  components: {
  },
  data() {
    return {
      IP_TEST: IP_TEST,
      imgAd: [],
      ArrZJs:[],
      plateIdInfo:"",
      ghplateIdInfo:"",
      ArrGuiHs:[]
    }
  },
  created() {
    this.getArticles("职业发展");
    this.getguiHArticles("职业规划")
  },
  filters: {
    datefilter(value) {
      return value.slice(0,10);
    }
  },
  methods: {
     _sortByTop(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].top == "1") {
          arr.unshift(arr[i]);
          arr.splice(i + 1, 1);
          break;
        }
      }
      return arr.slice(0,6);
    },
    async getArticles(platename) {
      let { plates } = this.$store.state;
      let list = plates.filter((item) => item.name == platename);
      let result_zj = await getArticles(list[0].uuid);
      this.plateIdInfo = list[0].uuid;
      result_zj = result_zj.data;
      this.ArrZJs = result_zj && this._sortByTop(result_zj);
    },
    async getguiHArticles(platename) {
      let { plates } = this.$store.state;
      let list = plates.filter((item) => item.name == platename);
      let result_zj = await getArticles(list[0].uuid);
      this.ghplateIdInfo = list[0].uuid;
      result_zj = result_zj.data;
      this.ArrGuiHs = result_zj && this._sortByTop(result_zj);
    }
  }
};
</script>
<style scoped>
.title{
  position: relative;
  padding-left: 25px;
  height: 24px;
font-size: 24px;
font-family: PingFang SC;
font-weight: bold;
color: #2E8EEB;
line-height: 24px;
}
.title:before {
  position: absolute;
  top:0;
  left: 0;
  content: "";
  display: inline-block;
  width: 8px;
  height: 24px;
  background: #2E8EEB;
}
.urlbox{
  position: relative;
  margin-top: 46px;
  width: 1300px;
  height: 103px;
  display: flex;
  justify-content: space-between;
}
.item{
  padding-left: 30px;
width: 280px;
font-size: 20px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
line-height: 103px;
}
</style>
